import { render, staticRenderFns } from "./tab-info.vue?vue&type=template&id=1413f2d1&scoped=true"
import script from "./tab-info.vue?vue&type=script&lang=js"
export * from "./tab-info.vue?vue&type=script&lang=js"
import style0 from "./tab-info.vue?vue&type=style&index=0&id=1413f2d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1413f2d1",
  null
  
)

export default component.exports